import * as actionType from "./actionTypes";
import axios from "../../shared/axios";
import { getFormatedArray } from "../../shared/firebaseHelper";

const fetchSkillsStart = () => ({
  type: actionType.FETCH_SKILLS_START,
});

const fetchSkillsSuccess = (skills) => ({
  type: actionType.FETCH_SKILLS_SUCCESS,
  skills,
});

const fetchSkillsFail = (error) => ({
  type: actionType.FETCH_SKILLS_FAIL,
  error,
});

export const fetchSkills = () => async (dispatch) => {
  dispatch(fetchSkillsStart());

  try {
    const res = await axios.get("skills.json");
    const fetchedSkills = getFormatedArray(res.data);
    const skills = fetchedSkills.reduce((acc, curr) => {
      const accIndex = acc.findIndex((elem) => elem.type === curr.type);
      accIndex !== -1
        ? acc[accIndex].values.push({ name: curr.name, level: curr.level })
        : acc.push({
            type: curr.type,
            values: [{ name: curr.name, level: curr.level }],
          });
      return acc;
    }, []);

    dispatch(fetchSkillsSuccess(skills));
  } catch (error) {
    dispatch(fetchSkillsFail(error.message));
  }
};
